import { useFeatureFlags } from "../contexts/FeatureFlagContext";
import type { FeatureAccess } from "../types";

const useFeatureFlag = (name: string): boolean => {
  const { isFeatureEnabled } = useFeatureFlags();
  return isFeatureEnabled(name);
};

/** Returns both enabled state and access level for showing test/admin badges */
export const useFeatureFlagAccess = (name: string): { enabled: boolean; access: FeatureAccess } => {
  const { isFeatureEnabled, getFeatureAccess } = useFeatureFlags();
  return { enabled: isFeatureEnabled(name), access: getFeatureAccess(name) };
};

export default useFeatureFlag;
